<template>
  <div class="estruturacao-section-page">
    <EstruturacaoPageHeader :section="section" />

    <div class="estruturacao-section-content">
      <EstruturacaoModuleLayout :section="section" />
    </div>
  </div>
</template>

<script setup>
import EstruturacaoPageHeader from '../components/estruturacao/EstruturacaoPageHeader.vue'
import EstruturacaoModuleLayout from '../components/estruturacao/EstruturacaoModuleLayout.vue'

defineProps({
  section: {
    type: Object,
    required: true
  }
})
</script>

<style scoped>
.estruturacao-section-page {
  min-height: 100%;
  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%);
}

.estruturacao-section-content {
  padding: 24px;
  max-width: 1600px;
  margin: 0 auto;
}

@media (max-width: 640px) {
  .estruturacao-section-content {
    padding: 16px;
  }
}
</style>
